/** 资源信息中与 RSS 相关的可选字段 */
export type RssRelatedFields = {
  feedUrl?: string | null;
  rssGuid?: string | null;
  rssPubDate?: string | null;
};

function hasNonEmptyString(value: unknown): boolean {
  return typeof value === 'string' && value.trim() !== '';
}

/**
 * 资源信息接口出现 rssGuid / rssPubDate / feedUrl 任一非空字段，即视为 RSS 相关。
 * 合集与 RSS 导入的单品均用此规则锁定编辑、停用草稿。
 */
export function isRssRelatedResource(info: RssRelatedFields | null | undefined): boolean {
  if (!info) {
    return false;
  }
  return (
    hasNonEmptyString(info.feedUrl) ||
    hasNonEmptyString(info.rssGuid) ||
    hasNonEmptyString(info.rssPubDate)
  );
}

/** 同步进度是否处于导入中（status 未返回时不算进行中） */
export function isRssSyncImporting(status: string | null | undefined): boolean {
  if (status == null) {
    return false;
  }
  // 空字符串与 pending/running 均视为进行中（与横幅 resolve 逻辑一致）
  return status === '' || status === 'pending' || status === 'running';
}
